<style>
  /* The Modal (background) */
  .modalcontainer {
    display: flex; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  }

</style>
<template>
  <div class="modalcontainer">
    <div class="ui active modal" id="photomodal" style="margin:auto;position:static">
      <div class="header">{{ data.title }}</div>
      <div class="content">
        <div class="description">
          {{ data.message }}
        </div>
      </div>
      <div class="actions">
        <button class="ui deny button" @click="closeModal">
          Ok
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data','isError'],
    methods: {
      closeModal() {
        this.$emit('closedEvent');
      }
    }
  }
</script>
